import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { loadSectionTexts } from '../../utils/contentService';

export default function ConfirmationHeader() {
  const { i18n } = useTranslation();
  const [texts, setTexts] = useState({});

  useEffect(() => {
    setTexts(loadSectionTexts('confirmation', i18n.language));
  }, [i18n.language]);

  return (
    <div className="mx-auto max-w-[1100px] px-4 pt-6 md:pt-[44px] relative">
      <a href="/" className="inline-flex items-center gap-2 text-black text-xl md:text-3xl font-normal font-serif hover:opacity-70 transition-opacity">
        <span>←</span> {texts.home || ""}
      </a>

      <div className="mt-10 md:mt-[40px] text-center">
        <h1 className="text-black text-[32px] md:text-7xl font-medium font-serif leading-tight">
          {texts.title || ""}
        </h1>
        <div className="w-full h-px bg-black mx-auto mt-8 md:mt-[100px] opacity-40 md:opacity-100"></div>
      </div>
    </div>
  );
}
